/* ============================================================================
   vault-product-meta.js - Storage / Drive download metadata for vault products
   Keep in sync with functions/vault-catalog.js VAULT_PRODUCT_META.
   ============================================================================ */

export const VAULT_PRODUCT_META = {
  "bg-exteriors": {
    has_vault_file: true,
    name: "Exteriors Set",
  },
  "bg-japanese-apartment": {
    has_vault_file: true,
    name: "Japanese Apartment Set",
  },
  "bg-cabin-house": {
    has_vault_file: true,
    name: "Cabin House Set",
  },
  "bg-beach-mansion": {
    has_vault_file: true,
    name: "Beach Mansion Set",
  },
  "bg-cafes-restaurants": {
    has_vault_file: true,
    name: "Cafes & Restaurants Set",
  },
  "bg-beach-resort": {
    has_vault_file: true,
    name: "Beach Resort Set",
  },
  "bg-high-school-remastered": {
    has_vault_file: true,
    name: "High School Set (Remastered)",
  },
  "bg-music-tour": {
    has_vault_file: true,
    name: "Music Tour Background Set",


  },
  "bg-b99-precinct": {
    has_vault_file: true,
    name: "Police Precinct Background Set",

  },
  "bg-office-set": {
    has_vault_file: true,
    name: "Office Background Set",

  },
  "tpl-phone-gallery": {
    has_vault_file: true,
    name: "Phone Gallery Template",

    episode_code_id: "tpl-phone-gallery",
    has_episode_code: true,
  },
  "ov-phone-overlays": {
    has_vault_file: true,
    name: "Phone Overlay Pack",

  },
  "tpl-wedding-ceremony-seats-front": {
    name: "Ceremony Seats Front Setup",
    episode_code_id: "tpl-wedding-ceremony-seats-front",
    has_episode_code: true,
    has_vault_download: false,
  },
  "bg-rustic-wedding": {
    has_vault_file: true,
    name: "Rustic Wedding Background Set",

  },
  "bg-bookstore": {
    has_vault_file: true,
    name: "Bookstore Background Set",

  },
  "bg-countryside-house": {
    has_vault_file: true,
    name: "Countryside House Background Set",

  },
  "bg-boho-apartment": {
    has_vault_file: true,
    name: "Boho Apartment Set",

  },
  "bg-boho-apartment-christmas": {
    has_vault_file: true,
    name: "Christmas Boho Apartment Set",

  },
  "bg-college-dormitory": {
    has_vault_file: true,
    name: "College Dormitory Set",

  },
  "bg-hospital": {
    has_vault_file: true,
    name: "Hospital Set",

  },
  "bg-musician-apartment": {
    has_vault_file: true,
    name: "Musician Apartment Set",

  },
  "bg-music-production": {
    has_vault_file: true,
    name: "Music Production Set",

  },
  "bg-gaming-set": {
    has_vault_file: true,
    name: "Gaming Set",

  },
  "bg-gamer-apartment": {
    has_vault_file: true,
    name: "Gamer Apartment",

  },
  "bg-night-club": {
    has_vault_file: true,
    name: "Night Club Set",

  },
  "bg-royal-castle": {
    has_vault_file: true,
    name: "Royal Castle Set",

  },
  "bg-living-room": {
    has_vault_file: true,
    name: "Living Room",

  },
  /* variant_sku: download/purchase ids only - never vault grid cards */
  "1_white_penthouse": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-living-room",
    name: "Living Room · White Penthouse",
  },
  "2_countryside": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-living-room",
    name: "Living Room · Countryside",
  },
  "3_beach_mansion": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-living-room",
    name: "Living Room · Beach Mansion",
  },
  "4_penthouse": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-living-room",
    name: "Living Room · Penthouse",
  },
  "5_japanese": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-living-room",
    name: "Living Room · Japanese",
  },
  "6_gamers": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-living-room",
    name: "Living Room · Gamer",
  },
  "1_bedroom_white_penthouse": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-bedroom",
    name: "Bedroom · White Penthouse",
  },
  "2_bedroom_royal_castle_blue": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-bedroom",
    name: "Bedroom · Royal Blue",
  },
  "3_bedroom_penthouse": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-bedroom",
    name: "Bedroom · Penthouse",
  },
  "4_bedroom_white_w_fireplace": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-bedroom",
    name: "Bedroom · White with Fireplace",
  },
  "5_mint_bedroom": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-bedroom",
    name: "Bedroom · Mint",
  },
  "6_guys_bedroom": {
    has_vault_file: true,
    variant_sku: true,
    parent_product_id: "bg-bedroom",
    name: "Bedroom · Red",
  },
  "bg-penthouse-set": {
    has_vault_file: true,
    name: "Penthouse Set",

  },
  "bg-white-penthouse": {
    has_vault_file: true,
    name: "White Penthouse",

  },
  "bg-white-penthouse-christmas": {
    has_vault_file: true,
    name: "White Penthouse Christmas Edition",

  },
  "mg-signature-cocktail": {
    has_vault_file: true,
    name: "Signature Cocktail Mini-Game",

    episode_code_id: "mg-signature-cocktail",
    has_episode_code: true,
  },
  "mg-cocktail-challenge": {
    has_vault_file: true,
    name: "Cocktail Challenge Mini-Game",

    episode_code_id: "mg-cocktail-challenge",
    has_episode_code: true,
  },
  "mg-phone-passcode": {
    has_vault_file: true,
    name: "Phone Passcode Mini-Game",
    episode_code_id: "mg-phone-passcode",
    has_episode_code: true,
  },
  "mg-dressing-game": {
    has_vault_file: true,
    name: "Dressing Game",
    episode_code_id: "mg-dressing-game",
    has_episode_code: true,
  },
  "mg-wardrobe-minigame": {
    has_vault_file: true,
    name: "Wardrobe Mini-Game",
    episode_code_id: "mg-wardrobe-minigame",
    has_episode_code: true,
  },
  "mg-wedding-outfit": {
    has_vault_file: true,
    name: "Wedding Outfit Mini-Game",
    episode_code_id: "mg-wedding-outfit",
    has_episode_code: true,
  },
  "tpl-tumbleweed": {
    has_vault_file: true,
    name: "Tumbleweed Rolling",

    episode_code_id: "tpl-tumbleweed",
    has_episode_code: true,
  },
  "tpl-cat-cc": {
    has_vault_file: true,
    name: "Cat Visual Customization",
    episode_code_id: "tpl-cat-cc",
    has_episode_code: true,
  },
  "tpl-dog-cc": {
    has_vault_file: true,
    name: "Dog Visual Customization",
    episode_code_id: "tpl-dog-cc",
    has_episode_code: true,
  },
  "ov-car-interior": {
    has_vault_file: true,
    name: "Car Interior Overlays",

  },
  "ov-mermaid-tails": {
    has_vault_file: true,
    name: "Mermaid Tails Overlays",

  },
  "ov-spaceships": {
    has_vault_file: true,
    name: "Spaceships Overlays",

  },
  "ov-female-limb-overlays": {
    has_vault_file: true,
    name: "Female Limb Overlays",

  },
  "ov-male-limb-overlays": {
    has_vault_file: true,
    name: "Male Limb Overlays",

  },
  "ov-unisex-limb-overlays": {
    has_vault_file: true,
    name: "Unisex Limb Overlays",

  },
};

function usableLink(value) {
  const link = String(value || "").trim();
  return link && link !== "#" ? link : "";
}

/** True for Bedroom / Living Room look SKUs (download rows, not vault cards). */
export function isVariantSkuProduct(productId) {
  const id = String(productId || "").trim();
  if (!id) return false;
  if (VAULT_PRODUCT_META[id]?.variant_sku) return true;
  // Defensive: purchase unlock docs use these id shapes even if meta drifts.
  if (/^\d+_bedroom_/.test(id) || id === "5_mint_bedroom" || id === "6_guys_bedroom") return true;
  if (/^\d+_(white_penthouse|countryside|beach_mansion|penthouse|japanese|gamers)$/.test(id)) {
    return true;
  }
  // CMS multi-look options: parentId__1_look-slug
  if (/^[a-z0-9-]+__\d+_/.test(id)) return true;
  return false;
}

/** Map a variant SKU id back to its parent vault product id. */
export function parentProductIdForSku(productId) {
  const id = String(productId || "").trim();
  const parent = VAULT_PRODUCT_META[id]?.parent_product_id;
  return parent ? String(parent).trim() : "";
}

/** Merge catalog flags. Download paths stay server-only (functions/vault-catalog.js). */
export function enrichVaultProduct(product) {
  if (!product?.id) return product;
  const meta = VAULT_PRODUCT_META[product.id] || {};
  const name = meta.variant_sku
    ? String(product.name || "").trim()
    : String(product.name || meta.name || "").trim();
  const out = {
    ...product,
    name: name || product.name,
    has_vault_download:
      product.has_vault_download === false || meta.has_vault_download === false
        ? false
        : product.has_vault_download ?? meta.has_vault_download,
    has_vault_file:
      product.has_vault_download === false || meta.has_vault_download === false
        ? false
        : Boolean(
            product.has_vault_file ||
              meta.has_vault_file ||
              product.has_vault_download === true
          ),
    has_episode_code: Boolean(product.has_episode_code ?? meta.has_episode_code ?? false),
    episode_code_id:
      String(product.episode_code_id || meta.episode_code_id || "").trim() || undefined,
    members_pantry: Boolean(product.members_pantry ?? meta.members_pantry ?? false),
    variant_sku: Boolean(product.variant_sku || meta.variant_sku),
    parent_product_id:
      String(product.parent_product_id || meta.parent_product_id || "").trim() || undefined,
    preview_images:
      Array.isArray(product.preview_images) && product.preview_images.length
        ? product.preview_images
        : Array.isArray(meta.preview_images)
          ? meta.preview_images
          : undefined,
  };
  if (product.admin_added && product.has_vault_download !== false) {
    const contents = product.asset_contents || {};
    const hasOverlays = contents.overlays === true || Number(contents.overlays) > 0;
    const category = String(product.category || "");
    if (product.has_vault_download === true || hasOverlays || category === "Overlays") {
      out.has_vault_download = true;
      out.has_vault_file = true;
      const mergedContents = { ...(out.asset_contents || {}), ...(contents || {}) };
      if (hasOverlays) {
        mergedContents.overlays = contents.overlays;
      } else if (category === "Overlays" && mergedContents.overlays == null) {
        mergedContents.overlays = true;
      }
      out.asset_contents = mergedContents;
    }
  }
  delete out.storage_path;
  delete out.link;
  return out;
}
